import React from "react";
import styles from "./TechnicalCapabilities.module.scss";
import Image from "next/image";

function TechnicalCapabilities() {
  const technicalCapabilities = [
    {
      category: "Infrastructure & Performance",
      icon: "<Cloud/>",
      capabilities: [
        "Auto-scaling cloud infrastructure (AWS/Azure)",
        "Global CDN with edge caching",
        "99.9% uptime SLA with redundancy",
        "Load balancing and traffic management",
        "Database optimization and caching layers",
      ],
    },
    {
      category: "Security & Compliance",
      icon: "<Shield/>",
      capabilities: [
        "End-to-end SSL encryption",
        "PCI DSS Level 1 compliance",
        "GDPR and data privacy compliance",
        "Two-factor authentication (2FA)",
        "Regular security audits and penetration testing",
      ],
    },
    {
      category: "Integration & APIs",
      icon: "<Settings/>",
      capabilities: [
        "RESTful and GraphQL API endpoints",
        "Webhook support for real-time notifications",
        "Third-party service integrations (ERP, CRM, etc.)",
        "Custom plugin and extension support",
        "API rate limiting and authentication",
      ],
    },
    {
      category: "Mobile & Omnichannel",
      icon: "<Smartphone/>",
      capabilities: [
        "Progressive Web App (PWA) support",
        "Native mobile app development",
        "Omnichannel inventory management",
        "Social commerce integration",
        "Voice commerce and AI assistant support",
      ],
    },
  ];
  return (
    <section className={styles["technical-section"]}>
      <div className={styles["container"]}>
        <div className={styles["header"]}>
          <h2 className="heading">Technical Capabilities</h2>
          <p className="subHeading">
            Enterprise-grade technical infrastructure and development
            capabilities
          </p>
        </div>

        <div className={styles["grid"]}>
          {technicalCapabilities?.map((tech, index) => (
            <div key={index} className={styles["card"]}>
              <div className={styles["card-header"]}>
                <div className={styles["icon"]}>
                  <Image
                    src="/agent-icons/target.svg"
                    alt={tech.category}
                    width={28}
                    height={28}
                    className={styles.whiteIcon}
                  />
                </div>
                <h3 className={styles["card-title"]}>{tech.category}</h3>
              </div>

              <div className={styles["capabilities"]}>
                {tech.capabilities.map((capability, capIndex) => (
                  <div key={capIndex} className={styles["capability-item"]}>
                    <Image
                      src="/agent-icons/current.svg"
                      alt={tech.category}
                      width={15}
                      height={15}
                      className={styles["feature-icon"]}
                    />
                    <span>{capability}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TechnicalCapabilities;
